import { Layout } from '@/components';
import { useState } from 'react';
import LoginForm from '@/components/sign-up/forms/login-form/LoginForm.tsx';
import ForgetPasswordForm from '@/components/sign-up/forms/forget-password-form/ForgetPasswordForm.tsx';
import '@/assets/styles/views/login/login.styles.scss';
const Forms = {
	LoginForm,
	ForgetPasswordForm
};

const LoginScreen = () => {
	const [activeForm, setActiveForm] = useState<string>('login');

	const handleFormChange = (form: string) => {
		setActiveForm(form);
	};

	const loginFormProps = {
		onClose: () => {},
		onFormChange: handleFormChange,
		showCloseButton: false
	};

	const forgetPasswordProps = {
		onClose: () => {},
		onFormChange: handleFormChange,
		showCloseButton: false
	};

	return (
		<Layout>
			<div className="login-screen">
				<div className="login-container">{activeForm === 'login' ? <Forms.LoginForm {...loginFormProps} /> : <Forms.ForgetPasswordForm {...forgetPasswordProps} />}</div>
			</div>
		</Layout>
	);
};

export default LoginScreen;
